import {
  Container as BaseContainer,
  Image,
  SizableText,
  SmartLink,
  Spinner,
  Stack,
  YStack,
  YStackProps,
  shadowStandard,
  useMedia,
} from '@my/ui'
import { H1, Logo } from 'app/components'
import { useAuth } from 'app/provider/auth'
import { OfferQueryOutput } from './queries'
import { RegisterButtons } from './components/register-buttons'
import { RedeemOfferButton } from '../../containers'
import { SolitoImage } from 'solito/image'

export interface OfferScreenProps {
  loading: boolean
  offer?: OfferQueryOutput
  error: any
  refetch: any
  slug: string
}

const Container = ({ children, ...props }: YStackProps) => {
  const media = useMedia()

  return (
    <BaseContainer flex={1} fd="column" ai="center" jc="center">
      <YStack
        flex={1}
        fd="column"
        ai="center"
        jc={media.sm ? 'flex-start' : 'center'}
        backgroundColor={media.sm ? '' : '$white'}
        width={'100%'}
        height={'100%'}
        {...props}
        {...(media.sm ? {} : shadowStandard)}
      >
        {children}
      </YStack>
    </BaseContainer>
  )
}

export const OfferScreenEmbed = (props: OfferScreenProps) => {
  const media = useMedia()
  const { user } = useAuth()

  if (props.loading) {
    return (
      <Container maxHeight={'100vh'}>
        <Spinner />
      </Container>
    )
  }

  const offer = props.offer?.Offers?.docs[0]

  if (!offer) {
    return (
      <Container maxHeight={'100vh'}>
        <H1 textAlign="left" size="$9" fow="600">
          Oops, somethings went wrong.
        </H1>
      </Container>
    )
  }

  return (
    <Container fd={media.sm ? 'column' : 'row'}>
      <Image
        className="embed-offer-image"
        // @ts-ignore it's fine it's only for web
        source={{
          uri: offer.featuredImage?.url,
          height: media.sm ? '200px' : '100%',
          width: media.sm ? '100%' : '50%',
        }}
        width={media.sm ? '100%' : '50%'}
        height={media.sm ? '200px' : '100%'}
        resizeMode="cover"
      />

      <YStack p="$4" ai="center" jc="center" flex={1}>
        <Container w="90%">
          <SmartLink
            aria-label="Go to brand page"
            Component={Stack}
            href={`/discounts/${offer.brand.slug}`}
            aspectRatio={1}
            bg="$white"
            br="$3"
            w={88}
            h={88}
            mt="$3.5"
            zIndex="$1"
            hoverStyle={{ opacity: 0.8 }}
            pressStyle={{ opacity: 0.75 }}
            focusStyle={{ opacity: 0.75 }}
          >
            <SolitoImage
              src={offer.brand.logo.url || 'https://img.clock.co.uk/640x360'}
              alt=""
              contentFit="contain"
              fill
              sizes="120px"
            />
          </SmartLink>

          <H1 textAlign="center" fow="600" size="$9" p="$4">
            {offer.name}
          </H1>

          <SizableText textAlign="center" size="$4" p="$4">
            {offer.description}
          </SizableText>

          <YStack gap="$4" p="$4" ai="center" jc="center">
            {user && <RedeemOfferButton offer={offer} isEmbed />}
            {!user && <RegisterButtons offerSlug={props.slug} embedUrl={offer.embedUrl} />}
          </YStack>
        </Container>

        <YStack p="$4" ai="center" jc="center">
          <SizableText textAlign="center" size="$4" p="$2">
            Verified by
          </SizableText>
          <Logo width={100} />
        </YStack>
      </YStack>
    </Container>
  )
}
